import { arrayToMap } from "../catalogueHelpers";

export * from "./shared";

/**
 * Uplifted WHOLE from `apps/web/src/helper/getReservationData.ts` — the table-reservation
 * grouping used by `saga/tableView`.
 *
 * ⚠️ **WEB-ONLY: `apps/mobile/src/helper/getReservationData.*` does not exist** (verified with
 * `ls`, not assumed — rule 4 / hazard 32). That is why this folder has only a `.desktop` variant.
 *
 * ⚠️ Deep-imports `catalogueHelpers/index.desktop` on purpose (hazard 6): `arrayToMap` exists in
 * both variants but DIVERGES — this platform's returns `null` for an empty input where the
 * other's returns `{}` — and this file's callers rely on the falsy-null form.
 */
export const getReservationData = (
    data: any[] = [],
    slotStart?: string,
    slotEnd?: string
) => {
    const map: Record<string, any> = {};

    const start = slotStart ? new Date(slotStart).getTime() : null;
    const end = slotEnd ? new Date(slotEnd).getTime() : null;

    data.forEach((row: any) => {
        const resourceId = row?.resource?.resourceId || row?.resourceId;
        if (!resourceId) return;

        const allReservations = [
            ...(row?.reservations || []),
            ...(row?.reservation ? [row.reservation] : []),
            ...(row?.runningReservation ? [row.runningReservation] : []),
        ];

        const validReservations = allReservations.filter((r: any) => {
            if (!r) return false;
            if (r.cancelled || r.status === "CANCELLED") return false;

            if (!start || !end) return true;

            const rStart = new Date(r.startTime || r.start).getTime();
            const rEnd = new Date(r.endTime || r.end).getTime();

            // overlap check
            return rStart < end && rEnd > start;
        });

        if (!validReservations.length) return;

        map[resourceId] = row;
        if (row?.reservations) {
            map[resourceId] = { ...row, reservations: validReservations };
        }

    });

    return map;
};

export const dataComparison = (prev: Record<string, any> = {}, curr: Record<string, any> = {}) => {
    const prevKeys = Object.keys(prev);
    const currentKeys = Object.keys(curr);

    if (prevKeys.length !== currentKeys.length || JSON.stringify(prevKeys) !== JSON.stringify(currentKeys)) {
        return false;
    }

    return prevKeys.every((key) => JSON.stringify(prev[key]) === JSON.stringify(curr[key]));
}